import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import AutocompleteObject from '../Shared/AutocompleteObject';
import AutocompleteVehicle from '../Shared/AutocompleteVehicle';
import Autocomplete from "vuejs-auto-complete";
import Autocomplete2 from "../Shared/Autocomplete2";
import VueTimepicker from "vue2-timepicker";
import AutocompleteAddress from "../Shared/AutocompleteAddress";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            companyId: '',
            selectedDriver: '',
            newSelectedDriver: null,
            choosedTime: {HH: '08' , mm: '00'},
            placeholderDriver: "Vozač",
            placeholderVehicle: "Vozilo",
            selectedVehicle: '',
            notClosedShift: [],
            newSelectedVehicle: null,
            scheduleToFinish: null,
            openEditVehicle: false,
            openPrintSchedule: false,
            editVehicleObj: null,
            vacationToEdit: null,
            openDeclineVacation: false,
            fromDate: new Date(),
            selectedDay: '',
            filter: '',
            isDateError : null,
            companyName: '',
            openAddOrder: false,
            showNotComplete: false,
            isDisabledAddButton: false,
            vehicles: [],
            types: [],
            drivers: [],
            schedules: [],
            vacationsRequested: [],
            vacations: [],
            vacationsNotes: [],
            couriersOnVacation: [],
            couriersOnLongVacation: [],
            schedulesId: [],
            mapScheduleToAdd: new Map(),
            editVehicleShiftObj: null,
            openEditShift: false,
            openAnotherShift: false,
            openShowComment: false,
            newSchedule: {
                courier: '',
                vehicle: {
                    registrationPlate: '',
                    name: '',
                    description: '',
                }
            },
            selectedImage: 0,
            selected: "",
            images: []
        }
    },
    computed: {
        filteredUsers() {
            return this.schedules.filter(item => {
                let firstFilter = (this.checkNullString(item.vehicle.name).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    this.checkNullString(item.vehicle.registrationPlate).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    this.checkNullString(item.courier.username).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    this.checkNullString(item.courier.firstName).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    this.checkNullString(item.courier.lastName).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    this.checkNullString(item.vehicle.description).toLowerCase().indexOf(this.filter.toLowerCase()) > -1)
                let secondFilter = this.showNotComplete ? item.completionTime == null : true
                return firstFilter && secondFilter
            }).sort((a,b) => this.compareByTime(a,b))
        },
        freeDaysDrivers() {
            return this.drivers.filter(item => {
                return checkNullString(item.freeDays).includes(this.selectedDay)
            })
        },
        filteredDrivers() {
            return this.drivers.filter(item => {
                return !this.couriersOnVacation.includes(item.id) && !this.couriersOnLongVacation.includes(item.id) && !this.schedulesId.includes(item.id) &&
                    this.checkNullString(item.lastName).toLowerCase().indexOf(this.filter.toLowerCase()) > -1
            })
        },
    },
    components: { Autocomplete,AutocompleteVehicle, AutocompleteObject,VueTimepicker },
    methods: {
        getVehicles: getVehicles,
        getImages: getImages,
        getDriverStartTime: getDriverStartTime,
        openAnotherShiftForCourier: openAnotherShiftForCourier,
        approveVacations: approveVacations,
        visibleButtons: visibleButtons,
        filterDrivers: filterDrivers,
        openDeclineVacationModal: openDeclineVacationModal,
        declineVacations: declineVacations,
        changeTimeForDriver: changeTimeForDriver,
        getVacationsForDate: getVacationsForDate,
        getVacationsRequested: getVacationsRequested,
        scheduleHasImages: scheduleHasImages,
        startDay: startDay,
        visibleDevelop: visibleDevelop,
        deleteVacation: deleteVacation,
        openSchedulePrint: openSchedulePrint,
        isVisibleDeleteButton: isVisibleDeleteButton,
        editVehicle: editVehicle,
        formatDateToTime: formatDateToTime,
        calculateHours: calculateHours,
        displayHoursAndMinutes: displayHoursAndMinutes,
        getVoucherStyle: getVoucherStyle,
        openRequested: openRequested,
        getVouchers: getVouchers,
        detectDay: detectDay,
        round: round,
        getSchedules: getSchedules,
        getReportFor2DaysAgo: getReportFor2DaysAgo,
        checkNull: checkNull,
        checkNullString: checkNullString,
        addSchedule: addSchedule,
        completeDay: completeDay,
        deleteSchedule: deleteSchedule,
        getDrivers: getDrivers,
        deleteVehicle: deleteVehicle,
        changedDate: changedDate,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        onClickUser: onClickUser,
        openAddUserModal: openAddUserModal,
        changeTime: changeTime,
        onSelectedDriver: onSelectedDriver,
        onSelectedVehicle: onSelectedVehicle,
        deleteSelectedDriver: deleteSelectedDriver,
        deleteSelectedVehicle: deleteSelectedVehicle,
        setNewDriver: setNewDriver,
        setNewVehicle: setNewVehicle,
        closeModal: closeModal,
        slideLeft: slideLeft,
        slideRight: slideRight,
        setNewVehicleInRow: setNewVehicleInRow,
        hasVehicle: hasVehicle,
        openShowCommentModal: openShowCommentModal,
        deleteVehicleForDriver: deleteVehicleForDriver,
        formatDate: formatDate,
        displayDate: displayDate,
        resetOrder: resetOrder,
        changeStartShift: changeStartShift,
        isAdmin: isAdmin,
        getDisplayStatus: getDisplayStatus,
        addScheduleForDriver: addScheduleForDriver,
        compareByTime(a, b) {
            var firstTime = 0.0
            var secondTime = 0.0

            try {
                firstTime = parseFloat(a.startShift.split(":")[0]) + parseFloat(a.startShift.split(":")[1])/100.0;
            }catch (e) { firstTime = 0.0;}
            try {
                secondTime = parseFloat(b.startShift.split(":")[0]) + parseFloat(b.startShift.split(":")[1])/100.0;
            }catch (e) { secondTime = 0.0;}

            let aTime = firstTime;
            let bTime = secondTime;
            if(aTime === bTime){
                return a.courier.firstName.localeCompare(b.courier.firstName)
            }
            if (aTime < bTime)
                return -1;
            if (aTime > bTime)
                return 1;
            return 0;
        },

        compareDriversByTime(a, b) {
            var firstTime = 0.0
            var secondTime = 0.0

            try {
                firstTime = parseFloat(a.choosedTime.HH) + parseFloat(a.choosedTime.mm)/100.0;
            }catch (e) { firstTime = 0.0;}
            try {
                secondTime = parseFloat(b.choosedTime.HH) + parseFloat(b.choosedTime.mm)/100.0;
            }catch (e) { secondTime = 0.0;}

            let aTime = firstTime;
            let bTime = secondTime;
            if(aTime === bTime){
                return a.firstName.localeCompare(b.firstName)
            }
            if (aTime < bTime)
                return -1;
            if (aTime > bTime)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeCompleteDay', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successCompleteDay', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno zatvoren dan', 'success')
            _self.getSchedules();
        });

        this.$topnavbar.$on('closeEditScheduleVehicle', () => {
            _self.openEditVehicle = false;
        });

        this.$topnavbar.$on('successEditScheduleVehicle', () => {
            _self.openEditVehicle = false;
            swal('Uspešno', 'Uspešno izmenjene tablice', 'success')
            _self.getSchedules();
        });

        this.$topnavbar.$on('closeDeclineVacation', () => {
            _self.openDeclineVacation = false;
        });
        this.$topnavbar.$on('successDeclineVacation', () => {
            _self.openDeclineVacation = false;
            swal('Uspešno', 'Uspešno odbijen godišnji', 'success')
            _self.getVacationsForDate();
        });

        this.$topnavbar.$on('closeEditScheduleShift', () => {
            _self.openEditShift = false;
        });

        this.$topnavbar.$on('successEditScheduleShift', () => {
            _self.openEditShift = false;
            swal('Uspešno', 'Uspešno izmenjene vreme smene', 'success')
            _self.getSchedules();
        });

        this.$topnavbar.$on('closeAnotherShift', () => {
            _self.openAnotherShift = false;
        });

        this.$topnavbar.$on('successAnotherShift', () => {
            _self.openAnotherShift = false;
            swal('Uspešno', 'Uspešno dodata smena', 'success')
            _self.getSchedules();
        });

        this.$topnavbar.$on('closeShowCommentSchedule', () => {
            _self.openShowComment = false;
            _self.getVacationsRequested();
        });

        this.$topnavbar.$on('closePrintSchedule', () => {
            _self.openPrintSchedule = false;
        });


    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.detectDay();
        this.getSchedules();
        this.getVehicles();
        this.getDrivers();
        this.getVacationsRequested()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
        newSelectedDriver: function(val, oldVal) {
            this.onSelectedDriver(val);
        },
        newSelectedVehicle: function(val, oldVal) {
            this.onSelectedVehicle(val);
        },
    }
}

function openShowCommentModal(){
    this.openShowComment = true
}

function changeTime(event) {
    if(event.mm !== '' && event.HH !== ''){
        // const newDate = new Date();
        // newDate.setHours(parseInt(event.HH), parseInt(event.mm), 0, 0);
        // const currentDate = new Date();
        // var diff = newDate.getTime() - currentDate.getTime();
        // var nextTime = Math.floor(diff / 60000);
        // if(nextTime > 0){
        //     this.newOrder.time = nextTime;
        // }
        //
        // this.visibleChooseTime = false;
    }
}

function openSchedulePrint(){
   this.openPrintSchedule = true
}

function openAnotherShiftForCourier() {
    this.openAnotherShift = true
}

function changeTimeForDriver(event, driver){

}

function changeStartShift(schedule){
    this.editVehicleShiftObj = schedule;
    this.openEditShift = true;
}

function openDeclineVacationModal(vacation){
    this.vacationToEdit = vacation;
    this.openDeclineVacation = true;
}

function getSchedules() {
    var _self = this;
    _self.notClosedShift = [];
    _self.drivers.forEach(d => {d.style = ''})
    var calendarTimestamp = Date.parse(_self.fromDate);
    if(isNaN(calendarTimestamp)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }

    _self.isDateError = null;
    _self.getVacationsForDate()

    _self.getReportFor2DaysAgo(calendarTimestamp - 86400000 * 2, calendarTimestamp - 86400000)
    var date =  "?fromTimestamp=" + calendarTimestamp + "&toTimestamp="+calendarTimestamp;
    AdminApiService.getSchedules(date)
        .then((response) => {
            _self.schedules = response.data
            _self.schedules.forEach( e => {e.style = ''})
            _self.schedulesId = _self.schedules.map(e => e.courier.id)
        })
        .catch((error) => {
            console.log(error);
            // swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getReportFor2DaysAgo(from, to) {
    var now = Date.now()
    if((to + 86399991) >= now) return
    let _self = this;
    var date =  "?fromTimestamp=" + from + "&toTimestamp="+to;
    AdminApiService.getSchedulesReport(date)
        .then((response) => {
            var nowMinusMin = Date.now() - 60000
            var notClosedShift = new Set()
            response.data.forEach(e => {
                if(e.schedules != null){
                    e.schedules.forEach(s => {
                        if(s.completionTime > nowMinusMin){
                            notClosedShift.add(e.id)
                        }
                    })
                }
            })
            _self.notClosedShift = Array.from(notClosedShift)
            _self.schedules.forEach(ss => {
                if(_self.notClosedShift.includes(ss.courier.id)){
                    ss.style = 'background: red;'
                }
            })

            _self.drivers.forEach(dd => {
                if(_self.notClosedShift.includes(dd.id)){
                    dd.style = 'background: red;'
                }
            })
            _self.filter = ' '
            _self.filter = ''
        })
        .catch((error) => {
            console.error(error)
        })
}

function getImages(schedule){
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });

    AdminApiService.getScheduleImages(schedule.id)
        .then((response) => {
            if(response.data.length === 0){
                swal('Info', 'Nema slika za raspored','warning');
                return;
            }
            swal.close();
            _self.images = response.data.map(e=> e.url)
            _self.selected = _self.images[0]
            _self.selectedImage = 0
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
        })
        .catch((error) => {
            swal('Greška', 'Greska pri ucitavanju slika.', 'error')
        })
}

function setNewDriver(event) {
    if(event == null || event.length === 0){
        this.newSelectedDriver = null;
    }else{
        this.newSelectedDriver = event;
    }

}

function setNewVehicle(event) {
    if(event == null || event.length === 0){
        this.newSelectedVehicle = null;
    }else{
        this.newSelectedVehicle = event;
    }
}

function setNewVehicleInRow(event, driver) {
    var obj = this.mapScheduleToAdd.get(driver.id)
    if(obj == null){
        obj = {vehicle: null, choosedTime: driver.choosedTime}
    }
    if(event == null || event.length === 0){
        obj.vehicle = null
    }else{
        obj.vehicle = event
    }
    this.mapScheduleToAdd.set(driver.id, obj);
    this.drivers.forEach(e=>{
        if(e.id === driver.id){
            e.visibleVehicle = obj.vehicle != null;
            e.vehicle = obj.vehicle;
        }
    })
    // console.log(this.mapScheduleToAdd)
    // console.log(this.drivers);
}

function deleteVehicleForDriver(driver){
    var obj = this.mapScheduleToAdd.get(driver.id)
    if(obj != null){
        obj.vehicle = null
    }
    this.mapScheduleToAdd.set(driver.id, obj)
    this.drivers.forEach(e=>{
        if(e.id === driver.id){
            e.visibleVehicle = false;
            e.vehicle = null;
        }
    })

    console.log(this.mapScheduleToAdd)
}

function hasVehicle(driver){
    const obj = this.mapScheduleToAdd.get(driver.id);
    if(obj == null) return false
    return obj.vehicle != null;
}

function deleteSelectedDriver() {
    this.newSchedule.courier = '';
    this.selectedDriver = '';
    this.newSelectedDriver = null;
}

function deleteSelectedVehicle() {
    this.newSchedule.vehicle.name = '';
    this.newSchedule.vehicle.description = '';
    this.newSchedule.vehicle.registrationPlate = '';
    this.selectedVehicle =  '';
    this.newSelectedVehicle = null;
}

function addScheduleForDriver(driver){
    let _self = this;
    var calendarTimestamp = Date.parse(_self.fromDate);
    if(isNaN(calendarTimestamp)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }

    if(driver.choosedTime.HH === "" || driver.choosedTime.mm === ""){
        swal('Greška', 'Izaberite  početak smene', 'error');
        return;;
    }

    if(driver.vehicle == null){
        swal('Greška', 'Izaberite  tablice za vozača', 'error');
        return;
    }
    console.log(driver.vehicle);
    let newModel = {
        courier: driver.id,
        vehicle: {
            id: driver.vehicle.id,
            registrationPlate: driver.vehicle.name,
            name: driver.vehicle.vehicle,
            description: driver.vehicle.description,
            averageSpending: driver.vehicle.averageSpending,
            fuel: driver.vehicle.fuel,
            kilometersTraveled: driver.vehicle.kilometersTraveled,
            smallService: driver.vehicle.smallService,
            lastSmallService: driver.vehicle.lastSmallService,
        },
        timestamp: calendarTimestamp,
        startShift: driver.choosedTime.HH + ":" + driver.choosedTime.mm
    }
    this.isDisabledAddButton = true;
    AdminApiService.createSchedules(newModel)
        .then((response) => {
            _self.$toasted.success('Uspešno otvorena smena',{ position: "top-right", duration: 2000})
            if(response.data.timestamps.length > 0){
                _self.$toasted.error(_self.selectedDriver+' ima nezatvorene smene za: ',{ position: "top-right", duration: 3000})
                response.data.timestamps.forEach(e => {
                    _self.$toasted.error(''+_self.formatDate(e),{ position: "top-right", duration: 3000})
                })
            }
            // swal('Uspešno', 'Uspešno kreiran raspored', 'success')
            _self.getSchedules();
            _self.resetOrder();
            this.isDisabledAddButton = false;

        })
        .catch((error) => {
            console.log(error)
            this.isDisabledAddButton = false;
            swal('Greška', error.data.message, 'error')

        })

}

function addSchedule() {
    var _self = this;
    if(_self.selectedDriver === "" ||
        _self.selectedVehicle === "") {
        swal('Greška', "Molimo popunite vozač i vozilo. ", 'error')
        return;
    }
    var calendarTimestamp = Date.parse(_self.fromDate);
    if(isNaN(calendarTimestamp)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    if(_self.choosedTime.HH === "" || _self.choosedTime.mm === ""){
        swal('Greška', 'Izaberite  početak smene', 'error');
        return;;
    }
    _self.newSchedule.timestamp = calendarTimestamp;
    _self.newSchedule.startShift = _self.choosedTime.HH + ":" + _self.choosedTime.mm;
    this.isDisabledAddButton = true;

    AdminApiService.createSchedules(_self.newSchedule)
        .then((response) => {
            _self.$toasted.success('Uspešno otvorena smena',{ position: "top-right", duration: 2000})
            if(response.data.timestamps.length > 0){
                _self.$toasted.error(_self.selectedDriver+' ima nezatvorene smene za: ',{ position: "top-right", duration: 3000})
                response.data.timestamps.forEach(e => {
                    _self.$toasted.error(''+_self.formatDate(e),{ position: "top-right", duration: 3000})
                })
            }
            // swal('Uspešno', 'Uspešno kreiran raspored', 'success')
            _self.getSchedules();
            _self.resetOrder();
            this.isDisabledAddButton = false;

        })
        .catch((error) => {
            console.log(error)
            this.isDisabledAddButton = false;
            swal('Greška', error.data.message, 'error')

        })
}

function completeDay(schedule) {
    this.scheduleToFinish = schedule;
    this.openAddOrder = true;
}

function resetOrder() {
    this.newSchedule = {
        courier: '',
            vehicle: {
            registrationPlate: '',
                name: '',
                description: '',
        }
    }
    this.deleteSelectedDriver()
    this.deleteSelectedVehicle()
    this.$topnavbar.$emit('clearACObject');

}

function onSelectedDriver(data) {
    if(data == null){
        this.newSchedule.courier = '';
        this.selectedDriver =  '';
        return;
    }
    if(this.newSchedule.courier.includes(data.name)) return;
    this.newSchedule.courier = data.id;
    this.selectedDriver =  data.name;
}


function onSelectedVehicle(data) {
    if(data == null){
        this.newSchedule.vehicle.name = '';
        this.newSchedule.vehicle.description = '';
        this.newSchedule.vehicle.registrationPlate = '';
        this.selectedVehicle =  '';
        return;
    }
    if(this.newSchedule.vehicle.name.includes(data.name)) return;
    this.newSchedule.vehicle.name = data.vehicle;
    this.newSchedule.vehicle.registrationPlate = data.name;
    this.newSchedule.vehicle.description = data.description;
    this.selectedVehicle =  data.name;
}

function getDrivers() {
    var _self = this;
    var activeParams = "";
    AdminApiService.getDrivers(activeParams)
        .then((response) => {
            _self.drivers = []
            _self.drivers = response.data.map(e => {
                return {
                    id: e.id,
                    visibleVehicle: false,
                    vehicle: null,
                    choosedTime: _self.getDriverStartTime(e),
                    name: e.lastName,
                    active: e.active,
                    firstName: e.firstName,
                    lastName: e.lastName,
                    startTime: e.startTime == null ? "08:00" : e.startTime,
                    style: '',
                    freeDays: checkNullString(e.freeDays)
                }
            }).sort((a,b) => _self.compareDriversByTime(a,b))
            _self.filterDrivers()
        })
        .catch((error) => {
            console.log(error);
            // swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getDriverStartTime(driver){
    var returnValue;
    try{
        var time = driver.startTime.split(":");
        returnValue = {HH: time[0] , mm: time[1]};
    }catch (e){
        returnValue = {HH: '08' , mm: '00'};
    }
    return returnValue;
}

function filterDrivers(){
    this.couriersOnLongVacation = [];
    this.drivers.filter(item => {
        return checkNullString(item.freeDays).includes(this.selectedDay)
    }).forEach(e => {
        this.couriersOnLongVacation.push(e.id);
    })
}

function changedDate() {
    this.drivers.forEach(e=>{
        e.visibleVehicle = false;
        e.vehicle = null;
        // e.choosedTime = e.choosedTime//{HH: '08' , mm: '00'};
    })
    this.mapScheduleToAdd = new Map()
    this.getSchedules();
    this.detectDay();
    this.filterDrivers();
}

function detectDay(){
    var calendarTimestamp = Date.parse(this.fromDate);
    var day = new Date(calendarTimestamp).getDay()
    switch (day) {
        case 1: this.selectedDay = "Ponedeljak"; return;
        case 2: this.selectedDay = "Utorak"; return;
        case 3: this.selectedDay = "Sreda"; return;
        case 4: this.selectedDay = "Četvrtak"; return;
        case 5: this.selectedDay = "Petak"; return;
        case 6: this.selectedDay = "Subota"; return;
        case 0: this.selectedDay = "Nedelja"; return;
    }
}

function openAddUserModal() {
    this.openAddOrder = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getVehicles() {
    var _self = this;
    AdminApiService.getVehicles()
        .then((response) => {
            _self.vehicles = response.data;
            _self.vehicles = response.data.map(e => {
                return {
                    id: e.id,
                    name: e.registrationPlate,
                    vehicle: e.name,
                    description: e.description,
                    averageSpending: e.averageSpending,
                    fuel: e.fuel,
                    kilometersTraveled: e.kilometersTraveled,
                    smallService: e.smallService,
                    lastSmallService: e.lastSmallService,
                }
            })
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehicles();
    }
}



function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}


function deleteVehicle(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete vozilo " + item.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteVehicle(item.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali vozilo', 'success')
                _self.getVehicles();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function deleteSchedule(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete raspored za " + item.courier.username + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteSchedule(item.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali raspored za ' + item.courier.lastName, 'success')
                _self.getSchedules();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function deleteVacation(vacation){
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete slobodan dan za: " + vacation.courier.lastName + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteVacation(vacation.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali slobodan za ' + vacation.courier.username, 'success')
                _self.getVacationsForDate();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function checkNull(data) {
    if(data == null) return 0;
    return data;
}


function round(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100
}

function getVoucherStyle(voucher) {
    switch (voucher) {
        case 'VOUCHER_BLUE': return "width: 30px; height: 24px; background: cornflowerblue; margin-right: 5px; color: black;";
        case 'VOUCHER_GREEN': return "width: 30px; height: 24px; background: forestgreen; margin-right: 5px; color: black;";
        case 'VOUCHER_WHITE': return "width: 30px; height: 24px; background: lightgrey; color: black;";
        default : return "width: 0px; height: 0px;"
    }
}

function getVouchers(voucher) {
    var list = [];
    if(voucher.length === 0) return list;
    var tempVouchers = voucher.split(";");
    tempVouchers.forEach(e => {
        var tempVoucher =  e.split("-");
        if(tempVoucher.length === 2){
            list.push({
                voucher: tempVoucher[0],
                count: parseInt(tempVoucher[1])
            })
        }
    });

    return list;
}

function calculateHours(schedule) {
    if(schedule.startTime == null || schedule.completionTime == null) return 0;
    var minutes = (schedule.completionTime - schedule.startTime)/60000;
    return Math.floor(minutes)
}

function displayHoursAndMinutes(minutes) {
    var hours = Math.floor(minutes / 60);
    var minutes = minutes % 60;
    return "" + hours + " H  "+minutes +" min"
}


function startDay(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da krene radno vreme za: " + item.courier.username + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        let newModel = {
            time: Date.now()
        }
        AdminApiService.startSchedule(item.id, newModel)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste započeli smenu za ' + item.courier.username, 'success')
                _self.getSchedules();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}


function formatDateToTime(date) {
    var localTime  =  date.toLocaleTimeString();
    var tempTime = localTime.split(':');
    return tempTime[0] + ':' + tempTime[1];
}

function editVehicle(obj) {
    this.openEditVehicle = true;
    this.editVehicleObj = obj;
}

function checkNullString(data) {
    if(data == null) return '';
    return data;
}

function openRequested(){
    this.$router.push('/drivers-vacations' );
}

function getVacationsForDate() {
    let _self = this;

    var calendarTimestamp = Date.parse(_self.fromDate);
    if(isNaN(calendarTimestamp)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    _self.isDateError = null;

    var from = new Date(calendarTimestamp);
    from.setUTCHours(0,0,0,0);
    var to =  new Date(calendarTimestamp);
    to.setUTCHours(23,59,59,999);
    AdminApiService.getAllVacations(from.getTime() + (new Date().getTimezoneOffset() * 60000) , to.getTime() + (new Date().getTimezoneOffset() * 60000) )
        .then((response) => {
            _self.vacations = response.data.filter(e => !(e.status === 'REQUESTED' && e.notes != null && e.notes.length !== 0));
            _self.couriersOnVacation = [];
            _self.vacations.forEach(e => {
                if(e.status === "APPROVED"){
                    _self.couriersOnVacation.push(e.courier.id);
                }
            })
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY')
}


function getDisplayStatus(status){
    switch (status){
        case "REQUESTED": return "Zahtevano";
        case "APPROVED": return "Odobreno";
        case "REJECTED": return "Odbijeno";
        default: return "";
    }
}

function visibleButtons(){
    return this.vacations.filter(e => e.status === "REQUESTED").length > 0;
}

function declineVacations(vacation){
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da želite da odbijete godišnji vozaču: "+ vacation.courier.firstName + " za: "+ _self.formatDate(vacation.date) + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.updateVacation(vacation.id, "REJECTED","")
            .then((response) => {
                _self.getVacationsForDate();
                _self.getVacationsRequested();
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function approveVacations(vacation){
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da želite da odobrite godišnji vozaču: "+ vacation.courier.firstName + " za: "+ _self.formatDate(vacation.date) + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.updateVacation(vacation.id, "APPROVED","")
            .then((response) => {
                _self.getVacationsForDate();
                _self.getVacationsRequested();
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function getVacationsRequested(){
    let _self = this;
    AdminApiService.getRequestedVacations()
        .then((response) => {
            _self.vacationsRequested = response.data.filter(e => !(e.status === 'REQUESTED' && e.notes != null && e.notes.length !== 0));
            _self.vacationsNotes = response.data.filter(e => (e.status === 'REQUESTED' && e.notes != null && e.notes.length !== 0));
            _self.$topnavbar.$emit('onGetVacation', _self.vacationsRequested.length);
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function displayDate(){
    var calendarTimestamp = Date.parse(this.fromDate);
    var date = new Date(calendarTimestamp).getTime()
    return this.$moment(new Date(date )).format('DD-MM-YYYY')
}

function visibleDevelop() {
    return localStorage.getItem('sb95') === 'braca'
}

function isAdmin(){
    return session.getRole() === 'ADMIN'
}


function slideLeft() {
    if(this.selectedImage === 0){
        this.selectedImage = this.images.length -1
    }else{
        this.selectedImage = this.selectedImage - 1
    }
    this.selected = this.images[this.selectedImage]
}

function slideRight() {
    if(this.selectedImage === (this.images.length - 1)){
        this.selectedImage = 0
    }else{
        this.selectedImage = this.selectedImage + 1
    }
    this.selected = this.images[this.selectedImage]
}

// function getSelectedImage() {
//     // return "background-image: url(\""+ this.images[this.selectedImage] +"\");"
//     return  this.images[this.selectedImage]
// }


function closeModal() {
    var modal = document.getElementById("myModal");
    modal.style.display = "none";
}

function scheduleHasImages(schedule){
    try{
        var plate = schedule.vehicle.registrationPlate;
        if(plate === "*" || plate === "B" || plate === "b"){
            return false;
        }
        return true;
    }catch (e){
        return false;
    }

}

function isVisibleDeleteButton(){
    return session.getRole() === 'ADMIN' || (session.getRole() === 'DISPATCHER' && session.getUsername() === 'Sonicsonic2011')
}



// WEBPACK FOOTER //
// ./src/components/Schedule/Schedule.js